import type { ReactNode } from "react";
import type { PickerItemData } from "@design-system/Picker/Picker.types";

const makeValue = (label: string) => `${label}-${crypto.randomUUID()}`;

const productPrices: Record<string, string[]> = {
    "Process Mastery": [
        "$1,000.00",
        "$750.00",
        "$500.00",
        "$250.00",
        "$100.00",
    ],
    "Silver Membership": ["$1,000.00", "$1,000.00", "$1,000.00"],
};

/**
 * The invoice item / price picker from the flyout decision: products whose
 * prices open in a searchable flyout with an "Add price" footer; single-price
 * products are leaves showing the price as right text.
 */
export const buildProductItems = (
    renderPriceFooter: (product: string, query: string) => ReactNode,
): Array<PickerItemData<string>> =>
    [
        ["Process Mastery", "Online course and consulting package"],
        ["Silver Membership", "Online and in-person membership"],
        ["Gold Membership", "Online and in-person membership", "$600.00"],
        ["Platinum Membership", "2026 retreat and online meetups", "$300.00"],
    ].map(([label, description, price]) => {
        const prices = productPrices[label];
        if (prices === undefined) {
            return {
                value: makeValue(label),
                label,
                description,
                rightText: price,
            };
        }
        return {
            value: makeValue(label),
            label,
            description,
            rightText: `${prices.length} prices`,
            children: prices.map((priceLabel, index) => ({
                value: makeValue(`${label}-${priceLabel}-${index}`),
                label: priceLabel,
                rightText: index === 0 ? "Default" : undefined,
            })),
            flyout: {
                searchable: true,
                searchPlaceholder: "Search...",
                renderFooter: (query: string) =>
                    renderPriceFooter(label, query),
            },
        };
    });
